import { useMsal } from '@azure/msal-react';
// import { isMobile, isIE } from 'react-device-detect';
// import Button from 'react-bootstrap/Button';
import React from 'react';
import { useLocation } from 'react-router-dom';

const LoginButton = ({skipLanding}) => {
  const { instance } = useMsal();

  const location = useLocation();
  
  const handleAzureLogin = () => {
    // const loginProm =
    //   isIE || isMobile ? instance.loginRedirect() : instance.loginPopup();

    const loginProm = instance.loginRedirect();
    loginProm.catch((error) => {
      console.log(error);
    });
  };

  const redirect = () => {
    window.location.replace(`${process.env.REACT_APP_host}/sign-in`);
  };

  const [isRedirectState, setIsRedirectState] = React.useState(false);

  React.useEffect(() => {
    const pathArr = location.pathname.split('/');
    const isRedirect = pathArr.includes('redirect'); // Retrieve the value of a specific query parameter
    setIsRedirectState(isRedirect);
    // console.log('🥥 use new haha');
    // console.log('🥉', isRedirect);
    /**
       * Don't display this page if skipLanding and direct go to azure authentication
       * won't take effect if it's redirect back after authentication finish
       */
    if (!isRedirect && skipLanding) {
      handleAzureLogin();
    }

  }, [])

  return (
    <>
      <style type='text/css'>
        {`
          .btn-primary-light {
            background-color: #FDE3E7;
            border-color: rgba(255, 255, 255, 0);
            padding: 0.58rem 0.75rem;
            border-radius: 52px;
            text-decoration: none !important;
            position: relative;
            outline: none !important;
            box-shadow: none !important;
            border: none;
            color: #D70E30 !important;
          }

          .btn-ausmed-primary {
            color: #fff;
            background-color: #F44F6C;
            border-color: rgba(255, 255, 255, 0);
            padding: 0.58rem 0.75rem;
            border-radius: 52px;
            text-decoration: none !important;
            position: relative;
            outline: none !important;
            box-shadow: none !important;
            border: none;
          }

          .btn-ausmed-primary:hover {
            color: #fff;
          }

        `}
      </style>
      {!skipLanding && !isRedirectState && <div className='d-flex flex-column justify-content-start mt-5'>
        <button className='btn btn-ausmed-primary mb-5' onClick={() => redirect()} >
            Sign in with Username
        </button>
        <button
          className='btn-primary-light'
          onClick={() => handleAzureLogin()}
        >
          Sign in with Azure
        </button>
      </div>}
    </>
  );
};

export default LoginButton;
